import {decryptJson} from './decryption';


export function checkAuthentication(user: string): boolean {
    try {
        if (user !== null && user !== "") {
            const decrypted = decryptJson(user, process.env.NEXT_PUBLIC_SECRET_KEY);

            if (
                decrypted.hasOwnProperty("id") &&
                decrypted.hasOwnProperty("last_login") &&
                decrypted.hasOwnProperty("is_superuser") &&
                decrypted.hasOwnProperty("username") &&
                decrypted.hasOwnProperty("is_staff") &&
                decrypted.hasOwnProperty("is_active") &&
                decrypted.hasOwnProperty("date_joined") &&
                decrypted.hasOwnProperty("email") &&
                decrypted.hasOwnProperty("first_name") &&
                decrypted.hasOwnProperty("last_name") &&
                decrypted.hasOwnProperty("organization") &&
                decrypted.hasOwnProperty("groups") &&
                decrypted.hasOwnProperty("user_permissions")
            ) {
                return decrypted.is_active ? true : false;
            } else {
                return false;
            }
        }
    } catch (error) {
        return false;
    }
};
